/**
 * helpers/palette.ts — chart colour tokens (PHASE2_SPEC §5).
 *
 * Hex values live here so chart components can pass colours straight to
 * recharts. CSS UI elements still use `var(--ok-600)` etc. — these constants
 * are ONLY for chart fills/strokes.
 */

export const NPA_COLORS = {
	standard: '#16a34a', // green
	subStandard: '#eab308', // yellow
	doubtful: '#f97316', // orange
	loss: '#dc2626', // red
} as const;

export const DEPOSIT_COLORS = {
	savings: '#2563eb', // blue
	fd: '#7c3aed', // purple
	rd: '#0891b2', // cyan
	current: '#475569', // slate
} as const;

/** Series colours for the trend line chart on Overview. */
export const TREND_COLORS = {
	loanCr: '#2b5894', // navy
	depositCr: '#0f9d6b', // ok-600
	npaCr: '#dc2626', // red
	npaPct: '#a8862f', // gold-600
} as const;

/** Per-product-type colour for the Products bar chart. */
export const PRODUCT_TYPE_COLORS: Record<string, string> = {
	LOAN: '#2b5894',
	DEPOSIT: '#0f9d6b',
	OTHER: '#6b7487',
};
